import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import FAQs from "./components/FAQs";
import Register from "./components/register/Register";
import PaymentTable from "./components/pages/PaymentTable";
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import SuccessPage from "./components/SuccessPage";
import FailurePage from "./components/FailurePage";
import BlogDetails from "./components/BlogDetails";
import Blogs from "./components/pages/Blogs";
import QrCards from "./components/QrCards";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Support from "./components/Support";
import UpgradeToPro from "./components/UpgradeToPro";
import Login from "./components/Login";
import RunningStrategies from "./components/RunningStrategies";
import RunStrategyActivity from "./components/RunStrategyActivity";
import Signup from "./components/Signup";
import PhoneNumberVerificationPage from "./components/PhoneNumberVerificationPage";
import AI from "./components/pages/AI";
import Cancellation from "./components/pages/Cancellation";
import TermsOfService from "./components/pages/TermsOfService";
import "./components/pages/Features.css";
import logogif from "./images/logo-progress.gif"; // Import your splash screen logo
import logotrns from "./images/logo-trns.png"; // Import your splash screen logo
import RevealContent from "./components/pages/RevealContent";
import BlogEditor from "./components/BlogEditor";
import BlogEdit from "./components/BlogEdit";
import { DashboardProvider } from "./context/DashboardContext";
import DashboardLayout from "./components/layout/DashboardLayout";
import FileUploader from "./components/fileupload/FileUploader";
import LatestUploadsViewer from "./components/fileupload/LatestUploadsViewer";

function AppContent() {
  const location = useLocation(); // Get current route

  // Define paths where Navbar and Footer should be hidden
  const hideNavbarFooterRoutes = [
    "/qrcard",
    "/dashboard",
    "/verify-phonenumber/:uid",
  ];

  const hidefooterRoutes = [
    "/login",
    "/signup",
    "/qrcard",
    "/dashboard",
    "/verify-phonenumber/:uid",
    "/setup-guide",
  ];

  // Check if the current path is one where Navbar and Footer should be hidden
  const shouldHideNavbarFooter = hideNavbarFooterRoutes.some((path) =>
    location.pathname.startsWith(path.replace(":uid", ""))
  );

  const shouldHideFooter = hidefooterRoutes.some((path) =>
    location.pathname.startsWith(path.replace(":uid", ""))
  );

  // Splash screen state
  const [showSplash, setShowSplash] = useState(true);

  // Simulate splash screen timeout
  useEffect(() => {
    const timer = setTimeout(() => setShowSplash(false), 1000); // 1 second
    return () => clearTimeout(timer);
  }, []);

  const strategy = {
    uid: "1",
    strategyName: "Strategy 1",
    displayName: "My First Strategy",
    sop: "Some SOP",
    maxLossPercentage: 10,
    maxLots: 5,
    maxProfitPercentage: 20,
    minProfitPercentage: 5,
    trending: "Yes",
    date: "2024-06-22",
    initialCapital: 10000,
    type: "Type A",
  };

  return (
    <>
      {showSplash ? (
        // Splash Screen
        <div className="splash-screen flex items-center justify-center h-screen bg-gray-100">
          <img src={logotrns} alt="Loading..." className="w-30 h-30 m-4" />
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-light tracking-tight mb-4">
            <span className="title-algo font-normal">algo</span>
            <span className="title-turtle font-normal">Turtle</span>
          </h1>
        </div>
      ) : (
        // Main App Content
        <>
          {!shouldHideNavbarFooter && <Navbar />}
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/faqs" exact element={<FAQs />} />
            <Route path="/register" exact element={<Register />} />
            <Route path="/pricing" exact element={<PaymentTable />} />
            <Route path="/about-us" exact element={<AboutUs />} />
            <Route path="/success" exact element={<SuccessPage />} />
            <Route path="/failure" exact element={<FailurePage />} />
            <Route path="/blogs" exact element={<Blogs />} />
            <Route path="/dashboard" exact element={<RunningStrategies />} />
            <Route path="/blog/:id" exact element={<BlogDetails />} />
            <Route path="/qrcard" exact element={<QrCards />} />
            <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
            <Route path="/customer-support" exact element={<Support />} />
            <Route path="/login" exact element={<Login />} />
            <Route path="/upgrade-to-pro" exact element={<UpgradeToPro />} />
            <Route path="/algoTurtle-ai" exact element={<AI />} />
            <Route path="/cancellation" exact element={<Cancellation />} />
            <Route path="/TermsOfService" exact element={<TermsOfService />} />
            <Route path="/setup-guide" exact element={<RevealContent />} />
            <Route
              path="/console"
              exact
              element={
                <DashboardProvider>
                  <DashboardLayout />
                </DashboardProvider>
              }
            />

            <Route path="/blog-editor" exact element={<BlogEditor />} />
            <Route path="/blog-editor/:id" element={<BlogEdit />} />
            <Route
              path="/verify-phonenumber/:uid"
              element={<PhoneNumberVerificationPage />}
            />
            <Route path="/signup" exact element={<Signup />} />
            <Route
              path="/upload-analysis-data"
              exact
              element={<FileUploader />}
            />

            <Route path="/signup" exact element={<Signup />} />
            <Route
              path="/analysis-data"
              exact
              element={<LatestUploadsViewer />}
            />
            <Route
              path="/runstrategy/:strategyName"
              element={<RunStrategyActivity strategy={strategy} />}
            />
          </Routes>
          {!shouldHideFooter && <Footer />}
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
